import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'ForwardRef',
	loadComponent: () => import('./ForwardRef' /* webpackChunkName: "ForwardRef" */),
}

export default entry
